<!-- BaseInput.vue (client) -->
<template tag="클라이언트 인풋 컴포넌트">
  <textarea
    v-if="textarea"
    :rows="rows"
    class="form_style"
    :class="{ input_error: error }"
    :placeholder="placeholder"
    v-model="model"
    :disabled="disabled"
  />
  <input
    v-else
    v-bind="$attrs"
    :type="type"
    class="form_style"
    :class="[{ input_error: error, border_none: border_none }, $attrs.class]"
    :placeholder="placeholder"
    :disabled="disabled"
    :readonly="readonly"
    v-model="model"
  />
  <span v-if="error && errorText" class="input_error_txt">{{ errorText }}</span>
</template>

<script setup lang="ts">
/* ------------------------------------------------------------
                          Model
   ------------------------------------------------------------ */
const model = defineModel<string | null>({ required: true, default: null });

/* ------------------------------------------------------------
                          Props
   ------------------------------------------------------------ */
defineProps({
  placeholder: {
    type: String,
    default: "", // placeholder 값
  },
  type: {
    type: String,
    default: "text", // 기본값을 "text"로 설정
  },
  textarea: {
    type: Boolean,
    default: false, // textarea 여부
  },
  rows: {
    type: Number,
    default: 4, // textarea 기본 행 수
  },
  error: {
    type: Boolean,
    default: false, // 에러 여부
  },
  errorText: {
    type: String,
    default: "", // 에러 메시지
  },
  disabled: {
    type: Boolean,
    default: false, // 비활성화 여부
  },
  readonly: {
    type: Boolean,
    default: false, // 읽기 전용 여부
  },
  border_none: {
    type: Boolean,
    default: false, // border_none 필요할 때 true로 변경
  },
});
</script>
